import type { Namespace } from './types';
export const zh: Namespace = {
  settings: {
    title: '个人设置',
    info: {
      title: '基本信息',
      username: '用户名',
      userId: '用户 ID',
      email: '邮箱',
    },
    edit: {
      title: '修改信息',
      tabs: {
        email: '邮箱',
        password: '密码',
      },
    },
    email: {
      label: '新邮箱',
      placeholder: '请输入新邮箱',
      submit: '保存邮箱',
      saved: '邮箱已更新',
    },
    password: {
      next: '新密码',
      nextPlaceholder: '请输入新密码',
      confirm: '确认新密码',
      confirmPlaceholder: '请再次输入新密码',
      required: '请输入这一项',
      submit: '修改密码',
      saved: '密码已修改',
      mismatch: '两次输入的新密码不一致',
    },
  },
};

export const en: Namespace = {
  settings: {
    title: 'Settings',
    info: {
      title: 'Profile',
      username: 'Username',
      userId: 'User ID',
      email: 'Email',
    },
    edit: {
      title: 'Edit profile',
      tabs: {
        email: 'Email',
        password: 'Password',
      },
    },
    email: {
      label: 'New email',
      placeholder: 'Enter the new email',
      submit: 'Save email',
      saved: 'Email updated',
    },
    password: {
      next: 'New password',
      nextPlaceholder: 'Enter a new password',
      confirm: 'Confirm new password',
      confirmPlaceholder: 'Enter the new password again',
      required: 'This field is required',
      submit: 'Change password',
      saved: 'Password changed',
      mismatch: 'The two new passwords do not match',
    },
  },
};
